import { render, staticRenderFns } from "./TianMuChildDevice.vue?vue&type=template&id=72be0b3e&scoped=true"
import script from "./TianMuChildDevice.vue?vue&type=script&lang=js"
export * from "./TianMuChildDevice.vue?vue&type=script&lang=js"
import style0 from "./TianMuChildDevice.vue?vue&type=style&index=0&id=72be0b3e&prod&lang=scss&scoped=true"
import style1 from "./TianMuChildDevice.vue?vue&type=style&index=1&id=72be0b3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be0b3e",
  null
  
)

export default component.exports